import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Route, Routes, useLocation } from 'react-router-dom';

// Import Routes all
import { authRoutes, nonUserRoutes, userRoutes } from "./routes/allRoutes";

import { ReactComponent as NotFoundIcon } from "./assets/icon/transaction_not_found.svg";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import { ToastContainer, toast } from "react-toastify";
import { ApiService } from "./components/Common/ApiService";
import { MaintenanceGuard } from "./components/Common/MaintenanceGuard";
import { setMetaData } from "./components/Common/metaHelper";
import { useHandleClickLoading } from './components/Common/utils';

import NonAuthLayout from './routes/NonAuthLayout';

function App() {
  const isPending = useSelector(state => state.todoReducer.isPending);
  const handleClickLoading = useHandleClickLoading();
  const isWebSetting = localStorage.getItem('isWebSetting');

  const location = useLocation();

  useEffect(() => {
    const checkAndProceed = () => {
      if (isWebSetting !== null) {
        setMetaData(isWebSetting, location);
        fetchData();
      } else {
        setTimeout(checkAndProceed, 1000); 
        fetchData();
      }
    };
    checkAndProceed();
  }, [isWebSetting]);

  useEffect(() => {
    const isLogin = localStorage.getItem('isLogin')
    if (isLogin) {
      const parseLogin = JSON.parse(isLogin)
      fetchDataProfile(parseLogin?.apiKey, parseLogin?.token)
    }
  }, [location]);

  const fetchData = async () => {
    try {
      const response = await ApiService({
        baseurl: 'user/web_setting',
        method: 'GET',
      });
      if (response?.statusCode === 200) {
        localStorage.setItem('isWebSetting', JSON.stringify(response?.result));
        setMetaData(response, location);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataProfile = async (api_key, token) => {
    try {
      const params = new URLSearchParams();
      params.append("api_key", api_key);

      const response = await ApiService({
        baseurl: "user/me",
        method: "POST",
        XGORDON: "ME",
        apiKey: api_key,
        token: token,
        body: params,
      });
      if (response?.statusCode === 200) {
        localStorage.setItem('isProfile', JSON.stringify(response?.result));
        if (response?.result.pin === "Tidak Aktif") {
          const timeoutId = setTimeout(() => {
            if (location.pathname !== "/me") {
              localStorage.setItem('isChoosePage', ('EditProfile'));
              localStorage.setItem('isSetPIN', (true));
              handleClickLoading("/me");
              toast.error("PIN Belum di Input", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }

          }, 500);
          return () => clearTimeout(timeoutId);
        }
      } else {

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <React.Fragment >
      <ToastContainer />
      <MaintenanceGuard>
        <Routes>
          {!localStorage.getItem("isLogin") ? (
              authRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    <NonAuthLayout>
                      {route.component}
                    </NonAuthLayout>
                  }
                  key={idx}
                  exact={true}
                />
              ))
          ) : (
              userRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    <Authmiddleware>
                      {route.component}
                    </Authmiddleware>
                  }
                  key={idx}
                  exact={true}
                />
              ))
          )}
            {nonUserRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    {route.component}
                  </Authmiddleware>}
                key={idx}
                exact={true}
              />
            ))}
          <Route path='*' element={
            <div className="flex  min-w-full min-h-screen items-center justify-center flex-col p-4 font-inter">
              <div className="gap-3 flex flex-col items-center container max-w-6xl">
               
              <NotFoundIcon className=" h-64 aspect-square"/>
                <span className="text-3xl font-bold text-center ">Page Not Found</span>
                <span className="text-base  text-center ">
                  Page yang anda akses tidak tersedia
                </span>
              </div>
            </div>
          } />
        </Routes>
      </MaintenanceGuard>
      {isPending &&
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-[#21212195]  z-50">
          <span>Loading</span>
        </div>
      }
    </React.Fragment>
  );
}

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
